<div class="permitir-recoger-core-wrapper">

  @if (device === devices.DESKTOP) {
    <app-direccion-compra-desktop></app-direccion-compra-desktop>
  }
  @if (device === devices.MOBILE) {
    <app-direccion-compra-mobile></app-direccion-compra-mobile>
  }

</div>